<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <div class="left-box">
            <div class="center-box-1">
              <span class="center-name">{{ formatDate }}</span>
            </div>
          </div>
          <el-form-item prop="schedulingStatus" label="状态">
            <el-radio-group v-model="form.schedulingStatus">
              <el-radio :label="1">出勤</el-radio>
              <el-radio :label="2">不出勤</el-radio>
            </el-radio-group>
          </el-form-item>
<!--          <el-form-item label="派单调度" prop="orderDispatcherId" v-if="form.schedulingStatus === 1">-->
<!--            <el-select style="width: 100%" v-model="form.orderDispatcherId" filterable clearable placeholder="请选择">-->
<!--              <el-option-->
<!--                v-for="item in userData"-->
<!--                :key="item.userId"-->
<!--                :label="item.username"-->
<!--                :value="item.userId"></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import {getDispatchers, getDriverScheduling, schedulingDriver} from "./api";
import dayjs from 'dayjs'
// 引入星期汉化
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "司机排班",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      detail: {},
      carImage: require("@/assets/imgs/title.png"),
      form: {
        schedulingStatus: null,
        schedulingDate: "",
        driverId: "",
        // orderDispatcherId: "",
      },
      rules: {
        // orderDispatcherId: [{ required: true, message: "调度不能为空" }],
        schedulingStatus: [{ required: true, message: "不能为空" }],
      },
      isEdit: false,
      userData: []
    };
  },
  // watch: {
  //   "form.schedulingStatus": function (val) {
  //     if (val === 2) {
  //       this.form.orderDispatcherId = "";
  //     }
  //   }
  // },
  computed: {
    formatDate: function () {
      return dayjs(this.form.schedulingDate).format('YYYY年MM月DD日 dddd')
    }
  },
  mounted() {},
  methods: {
    init(row, driverId, dispatcherId) {
      // this.form.orderDispatcherId = ""
      // if (dispatcherId) {
      //   this.form.orderDispatcherId = dispatcherId
      // }
      // this.getDispatchersData()
      this.form.schedulingStatus = row.schedulingStatus
        ? row.schedulingStatus
        : 1;
      this.form.driverId = driverId;
      // this.form.schedulingStatus = row.schedulingStatus;
      this.form.schedulingDate = row.scheduledDate;
      // this.form.orderDispatcherId = row.orderDispatcherId;
      this.dialogObj.show = true;
    },
    // getDispatchersData() {
    //   getDispatchers().then((res) => {
    //     if (res.code === 200) {
    //       this.userData = res.data;
    //     }
    //   })
    // },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            schedulingDate: this.form.schedulingDate,
            driverId: this.form.driverId,
            schedulingStatus: this.form.schedulingStatus,
            // orderDispatcherId: this.form.orderDispatcherId,
          };
          schedulingDriver(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("排班成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .left-box {
    padding-right: 0.5rem;
    padding-bottom: 0.1rem;
    position: relative;
    display: flex;
    align-items: center;
    .left-box-top {
      display: flex;
      align-items: center;
      .label {
        width: 0.2rem;
        height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.02rem;
        font-size: 0.12rem;
      }
      .zhuang {
        color: #5cc41a;
        background-color: rgba(92, 196, 26, 0.3);
      }
      .xie {
        color: #e52019;
        background-color: rgba(229, 32, 25, 0.3);
      }
      .name {
        color: #000000;
        font-size: 0.18rem;
        line-height: 0.2rem;
        padding-left: 0.04rem;
      }
    }
    .date {
      color: #8c8c8c;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
  .left-box:nth-last-of-type(1)::before {
    display: none;
  }
  .car-img {
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.04rem;
  }
  .center-box-2 {
    display: flex;
    align-items: center;
    line-height: 0.24rem;
    color: #000000;
    font-size: 0.12rem;
    position: relative;
  }
  .center-box-2 {
    padding-left: 0.2rem;
    position: relative;
    &::before {
      content: "";
      width: 0.01rem;
      height: 0.1rem;
      background-color: #dce5f5;
      position: absolute;
      left: 0.1rem;
    }
  }
  .center-box-1 {
    color: #1269ff;
    font-size: 20px;
  }
}
</style>
